import { useEffect } from 'react';

const useHostbackButton = (callback: () => void) => {
  useEffect(() => {
    if (callback) {
      const handlePopState = () => callback();
      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
  }, [callback]);
};

const useUndepsHostbackButton = (callback: () => void) => {
  useEffect(() => {
    if (callback) {
      const handlePopState = () => callback();
      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useHostbackButton;
export { useUndepsHostbackButton };
